import { BaseApi } from 'src/api/BaseApi';
import { DEMO_NOTES } from 'src/api/demo/notes';

class NotesApi extends BaseApi {
  async fetchNotes(queryID, whoAmI) {
    if (this.isDemo()) {
      return DEMO_NOTES[queryID] || [];
    }

    const formData = this.createFormData({
      queryID,
    });

    if (whoAmI) {
      formData.append('whoAmI', whoAmI.toString());
    }

    const response = await this.postRequest('queries/notes', formData);

    return response.data;
  }

  async addNote(queryID, content, whoAmI) {
    if (this.isDemo()) {
      return this.createDemoSuccessResponse({
        id: Date.now(),
        note: {
          id: Date.now(),
          queryID,
          content,
          whoAmI,
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
        },
      });
    }

    const formData = this.createFormData({
      queryID,
      content,
    });

    if (whoAmI) {
      formData.append('whoAmI', whoAmI.toString());
    }

    const response = await this.postRequest('queries/note/add', formData);
    return response.data;
  }

  async editNote(noteID, content, whoAmI) {
    if (this.isDemo()) {
      return this.createDemoSuccessResponse({
        noteID,
        note: {
          id: noteID,
          content,
          updatedAt: new Date().toISOString(),
        },
      });
    }

    const formData = this.createFormData({
      noteID,
      action: 'edit',
      content,
    });

    if (whoAmI) {
      formData.append('whoAmI', whoAmI.toString());
    }

    const response = await this.postRequest('queries/note/edit', formData);
    return response.data;
  }

  async deleteNote(noteID, whoAmI) {
    if (this.isDemo()) {
      return this.createDemoSuccessResponse({
        noteID,
        deleted: true,
      });
    }

    const formData = this.createFormData({
      noteID,
      action: 'delete',
    });

    if (whoAmI) {
      formData.append('whoAmI', whoAmI.toString());
    }

    const response = await this.postRequest('queries/note/edit', formData);
    return response.data;
  }
}

export const notesApi = new NotesApi();

